module.exports = __webpack_public_path__ + "static/media/window-close.be9054c0.svg";